export const TYPE_YOUR_MESSAGE = 'Type your message...';
export const PREVIEW_AUTO_RESPONSE = 'Hi there! To see Wix Chat in action, Publish your site and open it in another window. See all your chats in Wix Engage or on your smartphone with the Wix App.';
export const TECHNICAL_ISSUE = 'We\'ll be back shortly.';



// WEBPACK FOOTER //
// ./chat-app/constants/messages.js